export const hasPrice = (prices, id) =>
	prices.hasOwnProperty(id) &&
	typeof prices[id] === "object" &&
	prices[id].offers;
